module.exports = __webpack_public_path__ + "img/menu-to-close-2.68222255.svg";